import {
    CreateBase,
    Form,
    Identifier,
    RaRecord,
    SaveButton,
    useGetIdentity,
    useListContext,
    useNotify,
    useRecordContext,
    useResourceContext,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';

import { Stack } from '@mui/material';
import { NoteInputs } from './NoteInputs';
import { MemberNoteInput, MissionNoteInput } from '@domain/notes';

const foreignKeyMapping = {
    member: 'memberId',
    mission: 'missionId',
};

export const NoteCreate = ({
    reference,
}: {
    reference: 'member' | 'mission';
}) => {
    const resource = useResourceContext();
    const record = useRecordContext();

    if (!record) return null;
    return (
        <CreateBase resource={resource} redirect={false}>
            <Form>
                <NoteInputs />
                <Stack direction="row">
                    <NoteCreateButton reference={reference} record={record} />
                </Stack>
            </Form>
        </CreateBase>
    );
};

const NoteCreateButton = ({
    reference,
    record,
}: {
    reference: 'member' | 'mission';
    record: RaRecord<Identifier>;
}) => {
    const notify = useNotify();
    const { identity } = useGetIdentity();
    const { reset } = useFormContext();
    const { refetch, setPage } = useListContext();

    if (!record) return null;

    const resetValues: MemberNoteInput | MissionNoteInput = {
        text: '',
        attachmentIds: [],
        attachmentsInput: [],
    };

    const handleSuccess = () => {
        reset(resetValues, { keepValues: false });
        setPage(1);
        refetch();
        notify('Note added');
    };
    return (
        <SaveButton
            type="button"
            label="Add this note"
            variant="contained"
            transform={data => ({
                authorId: identity?.id, // first to keep the original authorId if any on edit
                ...data,
                [foreignKeyMapping[reference]]: record.id,
            })}
            mutationOptions={{
                onSuccess: handleSuccess,
            }}
        />
    );
};
